/* eslint-disable react/prop-types */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import { Button, Menu, Dropdown, Row, Col } from 'antd';
import s from './Navigation.css';
import Link from '../Link';
const rootSubmenuKeys = ['sub1', 'sub2', 'sub3', 'sub4'];

export default function Navigation(props) {
  useStyles(s);

  const listMenu = [
    {
      menu: props.language !== 'ind' ? 'Loyola Foundation' : 'Yayasan Loyola',
      subMenu: [
        {
          name: props.language !== 'ind' ? 'About Us' : 'Tentang Kami',
          path: '/TentangKami',
          isNewTab: false,
        },
        {
          name:
            props.language !== 'ind' ? 'Management Profile' : 'Profil Pengurus',
          path: '/ProfilPengurus',
          isNewTab: false,
        },
        {
          name:
            props.language !== 'ind' ? 'Story of Loyola Alumni' : 'Cerita KEKL',
          path: '/CeritaKEKL',
          isNewTab: false,
        },
        {
          name: props.language !== 'ind' ? 'Schedule' : 'Jadwal',
          path: '/Jadwal',
          isNewTab: false,
        },
        {
          name: props.language !== 'ind' ? 'Gallery' : 'Galeri',
          path: '/Galeri',
          isNewTab: false,
        },
      ],
    },
    {
      menu: props.language !== 'ind' ? 'Information' : 'Informasi',
      subMenu: [
        {
          name:
            props.language !== 'ind'
              ? 'From Establishment until Before 2017'
              : 'Pendirian s.d. Sebelum Tahun 2017',
          path: '/Informasi/1',
          isForce: true,
          isNewTab: false,
        },
        {
          name:
            props.language !== 'ind'
              ? 'From 2017 until Now'
              : 'Tahun 2017 s.d. Sekarang',
          path: '/Informasi/2',
          isForce: true,
          isNewTab: false,
        },
        {
          name: props.language !== 'ind' ? 'Future Project' : 'Langkah ke Depan',
          path: '/Informasi/langkah-kedepan',
          isNewTab: false,
        },
        {
          name: props.language !== 'ind' ? 'News / Announcement' : 'Pengumuman',
          path: '/pengumuman',
          isNewTab: false,
        },
      ],
    },
    {
      menu:
        props.language !== 'ind' ? 'Development Funding' : 'Dana Pengembangan',
      subMenu: [],
    },
    {
      menu: 'Magis!',
      subMenu: [],
    },
    {
      menu: props.language !== 'ind' ? 'Our School' : 'Sekolah Kami',
      subMenu: [],
    },
    {
      menu: props.language !== 'ind' ? 'Alumni' : 'Alumni',
      subMenu: [],
    },
  ];
  const [menu, setMenu] = useState(props.addMenu);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const menuTemp = mappingMenus(props.addMenu);
    setMenu(menuTemp);
  }, [props.addMenu]);

  useEffect(() => {
    window.addEventListener('scroll', val => {
      setVisible(false);
    });
  }, []);

  const clickItem = () => {
    setVisible(false)
    props.closeNav()
  }

  const mappingMenus = data => {
    const menu = [];
    listMenu.map((res, index) => {
      if (index == 3) {
        menu.push(data && data.magis ? data.magis : res);
      } else if (index == 4) {
        const resTemp = {
          ...res,
          subMenu: [
            {
              name: 'SMA Kolese Loyola',
              path: data && data.sekolah ? data.sekolah : '',
              isNewTab: true,
            },
          ],
        };
        menu.push(data && data.sekolah ? resTemp : res);
      } else if (index == 5) {
        menu.push(data && data.alumni ? data.alumni : res);
      } else if (index == 2) {
        menu.push(data && data.danaPembangunan ? data.danaPembangunan : res);
      } else {
        menu.push(res);
      }
    });
    return menu;
  };

  return props.isMobile ? (
    <div className={s.root} role="navigation" style={{ textAlign: 'left' }}>
      {menu &&
        menu.map((item, index) => {
          if (item && item.subMenu && item.subMenu.length > 0) {
            return (
              <React.Fragment key={index+'a'}>
                {item.subMenu && (
                  <Row>
                    <Col span={24}>
                      <Button type="link">
                        <Dropdown
                          overlay={
                            <Menu className={s.navMenu}>
                              {item.subMenu &&
                                item.subMenu.map((sub, indexSubmenu) => {
                                  return (
                                    <Menu.Item
                                      key={indexSubmenu}
                                      className={s.navMenuItem}
                                      onClick={_ => clickItem() }
                                    >
                                      <Link
                                        className={s.link}
                                        to={sub.path}
                                        isForce={sub.isForce}
                                        newTab={sub.isNewTab}
                                      >
                                        {sub.name}
                                      </Link>
                                    </Menu.Item>
                                  );
                                })}
                            </Menu>
                          }
                          visible={visible === (index + 1)}
                          onVisibleChange={_ => {
                            setVisible(!visible ? (index + 1) : false);
                          }}
                          trigger={['click']}
                          placement="bottomCenter"
                        >
                          <span className={s.titleHeader}>{item.menu}</span>
                        </Dropdown>
                      </Button>
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            );
          }
        })}
    </div>
  ) : (
    <div className={s.root} role="navigation">
      {menu &&
        menu.map((item, index) => {
          if (item && item.subMenu && item.subMenu.length > 0) {
            return (
              <React.Fragment key={index}>
                {item.subMenu && (
                  <Button type="link">
                    <Dropdown
                      overlay={
                        <Menu className={s.navMenu}>
                          {item.subMenu &&
                            item.subMenu.map((sub, index) => {
                              return (
                                <Menu.Item
                                  key={index}
                                  className={s.navMenuItem}
                                  onClick={_ => {setVisible(false)}}
                                >
                                  <Link
                                    className={s.link}
                                    to={sub.path}
                                    isForce={sub.isForce}
                                    newTab={sub.isNewTab}
                                  >
                                    {sub.name}
                                  </Link>
                                </Menu.Item>
                              );
                            })}
                        </Menu>
                      }
                      visible={visible === index + 1}
                      onVisibleChange={_ => {
                        setVisible(!visible ? index + 1 : false);
                      }}
                      trigger={['click']}
                      placement="bottomCenter"
                    >
                      <span className={s.titleHeader}>{item.menu}</span>
                    </Dropdown>
                  </Button>
                )}
              </React.Fragment>
            );
          }
        })}
    </div>
  );
}
